module.exports = __webpack_public_path__ + "static/media/enel-image-header.567eacb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enel-image-header.png
// module id = 267
// module chunks = 0